<section
  class="quote-details"
  [attr.aria-label]="'Quote details for ' + vendorName()"
>
  <!-- Back button -->
  <button
    type="button"
    class="quote-details__back"
    (click)="back.emit()"
    aria-label="Go back to estimates list"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
    >
      <path
        d="M4 8L0 4L4 0L4.93333 0.933333L1.86667 4L4.93333 7.06667L4 8Z"
        fill="#D0006F"
      />
    </svg>
    Back
  </button>

  <!-- Header: vendor name + download link -->
  <div class="quote-details__header">
    <h3 class="quote-details__vendor-name">{{ vendorName() }}</h3>
    <button
      type="button"
      class="quote-details__download"
      data-testid="quote-details-view-pdf"
      aria-label="View Quote PDF"
      (click)="generateQuotePDF()"
    >
      View Quote PDF
    </button>
  </div>

  <!-- Job Requirement Change Banner -->
  @if (hasAnyReclassification()) {
    <div
      class="quote-details__reclassification-banner"
      role="alert"
      data-testid="job-requirement-change-banner"
    >
      <mat-icon class="quote-details__banner-icon" aria-hidden="true"
        >info</mat-icon
      >
      <p class="quote-details__banner-text">
        <strong>Job Requirement Change:</strong> While reviewing your files for
        translation, the vendor identified some changes regarding Desktop
        Publishing needs. If you select this quote, these changes will be
        reflected in the Job Details tab. For more details please expand the
        Document Requirement Changes accordion.
      </p>
    </div>
  }

  <!-- Quote cards per delivery type -->
  <div class="detail-wrapper">
    @for (row of rows(); track row.jobType) {
      <article class="quote-details__card" data-testid="quote-summary-card">
        <!-- Info header -->
        <div class="quote-details__info">
          <div class="quote-details__info-col">
            <span class="quote-details__info-label">Delivery type</span>
            <span
              class="quote-details__info-value"
              data-testid="quote-summary-delivery-type"
            >
              <mat-icon
                class="quote-details__clock-icon"
                [svgIcon]="row.jobType === 'Rushed' ? 'bolt' : 'pace'"
                aria-hidden="true"
              ></mat-icon>
              {{ row.jobType }}
            </span>
          </div>
          <div class="quote-details__info-col">
            <span class="quote-details__info-label">Delivery date</span>
            <span
              class="quote-details__info-value quote-details__info-value--bold"
              data-testid="quote-summary-delivery-date"
              >{{ row.deliveryDate }}</span
            >
          </div>
          <div
            class="quote-details__info-col quote-details__info-col--quote-id"
          >
            <span class="quote-details__info-label">Quote ID</span>
            <span
              class="quote-details__info-value quote-details__info-value--bold"
              data-testid="quote-summary-quote-id"
              >{{ quoteId() }}</span
            >
          </div>
          @if (showSelectQuote()) {
            <div
              class="quote-details__info-col quote-details__info-col--action"
            >
              <app-vendor-select-btn
                [order]="order()!"
                [estimate]="estimate()"
                [selectedQuoteType]="row.jobType"
                [hasLowestRate]="isLowestRate()"
                (quoteConfirmed)="quoteConfirmed.emit($event)"
              />
            </div>
          }
        </div>

        <!-- Cost breakdown -->
        @if (getCostBreakdown(row.quote).length) {
          <div class="quote-details__breakdown">
            @for (item of getCostBreakdown(row.quote); track item.concept) {
              <div class="quote-details__breakdown-row">
                <p class="quote-details__breakdown-concept">
                  {{
                    item.concept === "Translation cost"
                      ? "Estimated linguistic review"
                      : item.concept
                  }}
                </p>
                <span class="quote-details__breakdown-cost">{{
                  item.cost | formatCurrency: currency()
                }}</span>
              </div>
            }
          </div>
        }

        <!-- Total cost -->
        <div class="quote-details__total">
          <div class="quote-details__total-label">Total cost</div>
          <div class="quote-details__total-value">
            {{ getTotalCost(row.quote) | formatCurrency: currency() }}
          </div>
        </div>
        <p class="quote-details__buffer-note">
          <strong>Note:</strong> Add a 15% buffer to your purchase order to
          account for potential adjustments in currency, tax, or review costs
          after file preparation.
        </p>
        <div class="quote-details__recommended">
          <span class="quote-details__recommended-label"
            >Recommended PO total</span
          >
          <span class="quote-details__recommended-value">
            <span class="quote-details__recommended-pct">+15%</span>=
            {{ getRecommendedPOTotal(row.quote) | formatCurrency: currency() }}
          </span>
        </div>
      </article>
    }
    <div class="blank-space"></div>
  </div>

  <!-- Document Requirement Changes section -->
  <app-document-requirement-changes
    [detail]="vendorJobDetails()"
    data-testid="quote-details-reclassification-section"
  />
</section>
